// Mirrors emergency_plan_gaps() in backend/routes/pre_construction_jha.py so a supervisor
// is warned about an incomplete emergency plan before submitting for approval.
const filled = (value) => Boolean(String(value ?? '').trim());
const listFilled = (items) => (items || []).some((v) => String(v ?? '').trim());

export const emergencyPlanGaps = (jha) => {
  const ep = jha?.emergencyPlan || {};
  const gaps = [];
  if (!filled(ep.nearestHospital)) gaps.push('Nearest hospital');
  if (!filled(ep.hospitalAddress)) gaps.push('Hospital address');
  if (!filled(ep.hospitalPhone)) gaps.push('Hospital phone');
  if (!listFilled(ep.evacuationRoutes)) gaps.push('Evacuation routes');
  if (!listFilled(ep.assemblyPoints)) gaps.push('Assembly points');
  const hasContact = (ep.emergencyContacts || []).some((c) =>
    ['role', 'name', 'phone'].some((k) => String(c?.[k] ?? '').trim())
  );
  if (!hasContact) gaps.push('Emergency contacts');
  return gaps;
};
